import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=0ecbc050&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=0ecbc050&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecbc050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ecbc050')) {
      api.createRecord('0ecbc050', component.options)
    } else {
      api.reload('0ecbc050', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=0ecbc050&scoped=true", function () {
      api.rerender('0ecbc050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SidebarA/Logo.vue"
export default component.exports